// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import DollarOutput from '../../utils/DollarOutput';

/* TODO: use enum after adding typscript */
const normalizeTransactionType = type => {
  switch (type) {
    case 'capture':
      return 'Charge';
    case 'refund':
      return 'Refund';
    case 'disputeCreated':
      return 'Dispute: Created';
    case 'disputeClosed':
      return 'Dispute: Closed';
    case 'disputeUpdated':
      return 'Dispute: Updated';
    case 'disputeSubmitted':
      return 'Dispute: Submitted';
    case 'disputeFundsReinstated':
      return 'Dispute: Funds Reinstated';
    default:
      return '';
  }
};

const parseDate = (createdAt, tz = null) =>
  tz
    ? moment(createdAt).tz(tz).format('MMM DD YYYY hh:mm A z')
    : moment(createdAt).format('MMM DD YYYY hh:mm A z');

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const TransactionRow = ({ transaction, tz }) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const { amount, createdAt, type } = transaction;

  return (
    <>
      <tr>
        <td>{normalizeTransactionType(type)}</td>
        <td>
          <DollarOutput value={-amount / 100} />
        </td>
        <td>{parseDate(createdAt, tz)}</td>
      </tr>
    </>
  );
};

export default TransactionRow;
